import { buildSearchReport } from "../kernel/search.js";
import { projectPositionSummary } from "../kernel/projectors.js";
import { loadPositionForCommand } from "../kernel/board-engine.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  SearchNextRequest,
  SearchShowRequest,
} from "../cli/protocol.js";

export async function handleSearchNext(
  context: ExecutionContext,
  request: SearchNextRequest,
) {
  const { board, position } = await loadPositionForCommand(context, request.s, request.p);
  const report = buildSearchReport(board, position, request.d);
  return {
    position: projectPositionSummary(position),
    report,
  };
}

export async function handleSearchShow(
  context: ExecutionContext,
  request: SearchShowRequest,
) {
  const { board, position } = await loadPositionForCommand(context, request.s, request.p);
  const report = buildSearchReport(board, position, request.d);
  return {
    position: projectPositionSummary(position),
    report,
  };
}
